module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "timeline-cover sp-page-banner"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-contents"
    }
  }, [_c('div', {
    staticClass: "card card-flat"
  }, [_c('div', [_c('h3', [_vm._v("Want to shop together with friends?")]), _vm._v(" "), (_vm.data_ref_link != '') ? _c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.data_ref_link))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReferralBash
    }
  }, [_vm._v("Generate Shopping Link")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('viewChatLog')
      }
    }
  }, [_vm._v("View Chat")]), _vm._v(" "), (_vm.menu_tab_view.viewChatLog) ? _c('div', [_c('h4', [_vm._v("Group Chat")]), _c('br'), _vm._v(" "), _c('component-chatroom', {
    attrs: {
      "chatter": {
        chatter_chat_from: _vm.user.user_id,
        chatter_chat_from_module: 1,
        chatter_set_active_chat: '16201620',
        chatter_chat_to: 16,
        chatter_chat_to_module: 20,
        chatter_chat_group: 16,
        chat_components_products: []
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [(_vm.set_shop_together) ? _c('div', [_c('h3', [_vm._v("Shop Together Active")]), _vm._v(" "), (_vm.data_ref_link != '') ? _c('div', {
    staticClass: "card card-flat-pad",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.data_ref_link))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setReferralBash
    }
  }, [_vm._v("Generate Shopping Link")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card card-flat"
  }, [(_vm.shop_together_join) ? _c('div', [_c('h3', [_vm._v("Do you want to shop together with "), _c('span', {
    staticClass: "sp-app-default-color"
  }, [_vm._v(_vm._s(_vm.ref_bash_details.ref_initiator_name))])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-1 sp-button-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.setShopTogetherJoinIn
    }
  }, [_vm._v("Yes, Please")])]) : _vm._e()])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Share the link below")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Invite more friends "), _c('br'), _vm._v("Share the link below")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60c6588d"}!./src/pages/Buypoint/template.html
// module id = 587
// module chunks = 0